import React, { useState, useRef, useEffect } from "react";

const initialImages = [
  {
    img: require("../../../assets/SellerDashboard/MyStore/MyStore/image242.jpg"),
  },
  {
    img: require("../../../assets/SellerDashboard/MyStore/MyStore/image397.jpg"),
  },
  {
    img: require("../../../assets/SellerDashboard/MyStore/MyStore/image399.jpg"),
  },
  {
    img: require("../../../assets/SellerDashboard/MyStore/MyStore/image400.jpg"),
  },
  {
    img: require("../../../assets/SellerDashboard/MyStore/MyStore/image401.jpg"),
  },
];

const MyStoreHome = () => {
  const [selectedImages, setSelectedImages] = useState([]);
  const [borderPosition, setBorderPosition] = useState({
    top: 0,
    left: 0,
    width: 0,
    height: 0,
  });
  const [bannerImages, setBannerImages] = useState(initialImages);
  const containerRef = useRef(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    // Load images from localStorage if available
    const storedImages = localStorage.getItem("bannerImages");
    if (storedImages) {
      setBannerImages(JSON.parse(storedImages));
    }
  }, []);

  const handleImageClick = (index, event) => {
    let newSelectedImages = [...selectedImages];
    if (newSelectedImages.includes(index)) {
      newSelectedImages = newSelectedImages.filter(
        (imgIndex) => imgIndex !== index
      );
    } else {
      if (newSelectedImages.length < 3) {
        newSelectedImages.push(index);
      }
    }
    setSelectedImages(newSelectedImages);

    const rect = event.target.getBoundingClientRect();
    const containerRect = containerRef.current.getBoundingClientRect();
    setBorderPosition({
      top: rect.top - containerRect.top,
      left: rect.left - containerRect.left,
      width: rect.width,
      height: rect.height,
    });
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    if (files && files.length <= 5) {
      const newImages = Array.from(files).map((file) => ({
        img: URL.createObjectURL(file),
      }));
      const updatedImages = [...bannerImages];
      newImages.forEach((newImage, index) => {
        if (index < updatedImages.length) {
          updatedImages[index] = newImage;
        }
      });
      setBannerImages(updatedImages);
      // Save images to localStorage
      localStorage.setItem("bannerImages", JSON.stringify(updatedImages));
    } else {
      alert("You can upload up to 5 images.");
    }
  };

  const handleAddImagesClick = () => {
    fileInputRef.current.click();
  };

  return (
    <div
      className="relative w-[891px] h-[630px] flex flex-col"
      ref={containerRef}
    >
      <p className="w-[352px] h-[21px] font-semibold text-[14px] text-black text-start mt-[30px]">
        My Promotional Banners{" "}
        <span className="text-black text-start font-medium text-[14px]">
          ( Select upto 3 images )
        </span>
      </p>
      <div className="w-full flex flex-wrap gap-[22px] items-center mt-[17px]">
        {bannerImages.map((item, index) => (
          <div
            key={index}
            className="relative p-0 cursor-pointer"
            onClick={(event) => handleImageClick(index, event)}
          >
            <img
              aria-hidden="true"
              src={item.img}
              alt={`Image ${index + 1}`}
              className="w-[275px] h-[146px]"
            />
            <div>
              {selectedImages.includes(index) ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  className="absolute top-2 right-2"
                >
                  <g filter="url(#filter0_d_5083_1512)">
                    <circle cx="14" cy="14" r="11" fill="#FF6300" />
                  </g>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.8067 10.2067C20.0644 10.4824 20.0644 10.9294 19.8067 11.205L13.6467 17.7932C13.5229 17.9256 13.355 18 13.18 18C13.005 18 12.8371 17.9256 12.7133 17.7932L9.19331 14.0285C8.93556 13.7528 8.93556 13.306 9.19331 13.0303C9.45105 12.7546 9.86895 12.7546 10.1267 13.0303L13.18 16.2958L18.8734 10.2067C19.1311 9.93108 19.5489 9.93108 19.8067 10.2067Z"
                    fill="white"
                  />
                  <defs>
                    <filter
                      id="filter0_d_5083_1512"
                      x="0.7"
                      y="0.7"
                      width="26.6"
                      height="26.6"
                      filterUnits="userSpaceOnUse"
                      colorInterpolationFilters="sRGB"
                    >
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset />
                      <feGaussianBlur stdDeviation="1.15" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_5083_1512"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_5083_1512"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  className="absolute top-2 right-2"
                >
                  <g filter="url(#filter0_d_5083_1510)">
                    <circle cx="14" cy="14" r="11" fill="white" />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_5083_1510"
                      x="0.7"
                      y="0.7"
                      width="26.6"
                      height="26.6"
                      filterUnits="userSpaceOnUse"
                      colorInterpolationFilters="sRGB"
                    >
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset />
                      <feGaussianBlur stdDeviation="1.15" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_5083_1510"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_5083_1510"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
              )}
            </div>
          </div>
        ))}
        {selectedImages.length > 0 && (
          <div
            className="absolute border-[3px] rounded-[10px] border-[#FF6300] pointer-events-none"
            style={{
              top: `${borderPosition.top}px`,
              left: `${borderPosition.left}px`,
              width: `${borderPosition.width}px`,
              height: `${borderPosition.height}px`,
            }}
          ></div>
        )}
      </div>
      <div className="w-full items-center justify-center flex mt-[60px]">
        <button
          className="w-[121px] h-[38px] bg-[#FF6300] rounded-[5px] flex items-center justify-center text-white font-semibold text-[14px]"
          onClick={handleAddImagesClick}
        >
          Add Images
        </button>
        <input
          type="file"
          ref={fileInputRef}
          multiple
          accept="image/*"
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
      </div>
      <p className="mt-[17px] font-medium text-[14px] text-black">
        ( Recommended size 1240px x 495px )
      </p>
    </div>
  );
};

export default MyStoreHome;
